/** Shared FeedBot presentation for the entry surfaces (organization, invitation). */

/** Primary action on `Button`. Local until shared tokens move to FeedBot in 43E2. */
export const AUTH_ENTRY_PRIMARY_ACTION =
  "h-12 w-full rounded-[12px] border-brand-primary bg-brand-primary px-5 text-[15px] font-[800] text-white shadow-[0_4px_11px_rgba(28,122,93,0.12)] not-disabled:hover:border-brand-primary-hover not-disabled:hover:bg-brand-primary-hover focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-brand/35 focus-visible:ring-offset-2 focus-visible:ring-offset-[#f8faf9]";

export const AUTH_ENTRY_SECONDARY_ACTION =
  "rounded-[9px] border-[#d6e2dc] bg-white font-[750] text-[#47665a] not-disabled:hover:border-brand not-disabled:hover:bg-[#f9fcfa] not-disabled:hover:text-brand-primary focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-brand/35";

/** Equal-size primary/secondary pair in one action row; layered on the action classes above. */
export const AUTH_ENTRY_PAIRED_ACTION = "h-[50px] w-full min-w-0 rounded-[12px] px-3 text-[15px]";

export const AUTH_ENTRY_INPUT =
  "h-12 w-full min-w-0 rounded-[12px] border border-[#d5e5dc] bg-white px-3.5 text-[15px] text-[#17302e] shadow-[0_2px_8px_#1c50300a] transition-[border-color,box-shadow] duration-150 ease-in-out placeholder:text-[#9aaba3] focus:border-brand focus:shadow-[0_0_0_3px_#55bca62e] focus:outline-none disabled:cursor-progress disabled:opacity-60 aria-invalid:border-[#efbcb5] aria-invalid:focus:border-[#e4928a] aria-invalid:focus:shadow-[0_0_0_3px_#e5675c1f]";

export const AUTH_ENTRY_FIELD_LABEL = "text-[13px] font-[750] text-[#2c4a40]";

export const AUTH_ENTRY_FIELD_ERROR = "m-0 text-[13px] leading-5 font-[600] text-[#c2453a]";

export const AUTH_ENTRY_SECTION_LABEL = "m-0 px-1 text-[11px] font-[800] text-[#59756a]";

export const AUTH_ENTRY_CARD =
  "rounded-[18px] border border-[#dce7df] bg-white shadow-[0_18px_50px_#1c503012]";

export const AUTH_ENTRY_ICON_WELL = "border-[#dce7df] bg-[#f3f8f6] text-[#5c7a70]";

export const AUTH_ENTRY_ICON_WELL_ACTIVE = "border-brand/30 bg-brand-mint text-brand-primary";

export const AUTH_ENTRY_ROW =
  "flex w-full min-w-0 items-center gap-3 rounded-[12px] border border-[#dce7df] bg-white px-3.5 py-3";

export const AUTH_ENTRY_ROW_TITLE = "block truncate text-[15px] leading-6 font-[700] text-[#17302e]";

export const AUTH_ENTRY_ROW_SUBTITLE = "block text-[12px] leading-5 text-[#82958b]";
